(function() {
  var $7934560493be717e$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("image-zoom")) return;
    customElements.define("image-zoom", class ImageZoom extends HTMLElement {
      hoverMQ=window.matchMedia("(hover: hover)");
      lensSize=192;
      lerpAmount=.7;
      scrollWakeThreshold=20;
      rafId=0;
      targetX=0;
      targetY=0;
      currentX=0;
      currentY=0;
      scrollWakeStartX=null;
      scrollWakeStartY=null;
      imgRect=null;
      lens=null;
      fullResSrc=null;
      active=false;
      scrollSuppressed=false;
      scrollEndTimer=0;
      scrollContainer=null;
      constructor() {
        super();
        this.onMouseEnter = e => this.showLens(e);
        this.onMouseMove = e => {
          if (this.scrollSuppressed) {
            if (this.scrollWakeStartX === null) {
              this.scrollWakeStartX = e.clientX;
              this.scrollWakeStartY = e.clientY;
              return;
            }
            const dx = e.clientX - this.scrollWakeStartX;
            const dy = e.clientY - this.scrollWakeStartY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance < this.scrollWakeThreshold) return;
            this.scrollSuppressed = false;
            this.scrollWakeStartX = null;
            this.scrollWakeStartY = null;
            this.cacheRect();
            if (this.imgRect) {
              const z = this.zoom;
              this.lens.style.backgroundSize = `${this.imgRect.width * z}px ${this.imgRect.height * z}px`;
            }
            this.lens?.classList.remove("hidden");
            this.targetX = e.clientX;
            this.targetY = e.clientY;
            this.currentX = e.clientX;
            this.currentY = e.clientY;
            if (!this.rafId) this.tick();
            return;
          }
          this.targetX = e.clientX;
          this.targetY = e.clientY;
          if (!this.rafId) this.tick();
        };
        this.onMouseLeave = () => this.hideLens();
        this.onScroll = () => this.handleScroll();
      }
      get zoom() {
        return parseFloat(this.dataset.zoom) || 3;
      }
      ensureLens() {
        if (this.lens) return;
        const lens = document.createElement("div");
        lens.className = [ "fixed", "w-48", "h-48", "hidden", "pointer-events-none", "border-4", "border-scheme-background", "bg-scheme-border", "bg-no-repeat", "z-[9999]" ].join(" ");
        lens.style.cssText = "left:0;top:0;will-change:transform,background-position;contain:strict;";
        document.body.appendChild(lens);
        this.lens = lens;
      }
      getFullResSrc(img) {
        const rawSrc = img.currentSrc || img.src;
        if (!rawSrc) return null;
        const url = new URL(rawSrc);
        url.searchParams.delete("width");
        return url.toString();
      }
      ensureFullResSrc() {
        if (this.fullResSrc) return true;
        const img = this.querySelector("img");
        if (!img || !img.complete && !img.currentSrc) return false;
        const src = this.getFullResSrc(img);
        if (!src) return false;
        this.fullResSrc = src;
        this.lens.style.backgroundImage = `url("${src}")`;
        const pre = new Image;
        pre.src = src;
        return true;
      }
      showLens(e) {
        this.ensureLens();
        if (!this.ensureFullResSrc()) return;
        this.active = true;
        this.scrollSuppressed = false;
        this.scrollWakeStartX = null;
        this.scrollWakeStartY = null;
        this.cacheRect();
        this.bindScroll();
        this.lens.classList.remove("hidden");
        if (this.imgRect) {
          const z = this.zoom;
          this.lens.style.backgroundSize = `${this.imgRect.width * z}px ${this.imgRect.height * z}px`;
        }
        this.targetX = e.clientX;
        this.targetY = e.clientY;
        this.currentX = this.targetX;
        this.currentY = this.targetY;
        if (!this.rafId) this.tick();
      }
      cacheRect() {
        const img = this.querySelector("img");
        if (img) this.imgRect = img.getBoundingClientRect();
      }
      tick() {
        if (!this.active || !this.imgRect || this.scrollSuppressed) {
          this.rafId = 0;
          return;
        }
        const dx = this.targetX - this.currentX;
        const dy = this.targetY - this.currentY;
        if (Math.abs(dx) < .1 && Math.abs(dy) < .1) {
          this.currentX = this.targetX;
          this.currentY = this.targetY;
          this.rafId = 0;
        } else {
          this.currentX += dx * this.lerpAmount;
          this.currentY += dy * this.lerpAmount;
          this.rafId = requestAnimationFrame(() => this.tick());
        }
        const {currentX: currentX, currentY: currentY, lensSize: lensSize, zoom: zoom} = this;
        const half = lensSize / 2;
        const relX = currentX - this.imgRect.left;
        const relY = currentY - this.imgRect.top;
        this.lens.style.transform = `translate3d(${currentX - half}px,${currentY - half}px,0)`;
        this.lens.style.backgroundPosition = `${(half - relX * zoom).toFixed(2)}px ${(half - relY * zoom).toFixed(2)}px`;
      }
      handleScroll() {
        if (!this.active) return;
        if (!this.scrollSuppressed) {
          this.scrollSuppressed = true;
          this.scrollWakeStartX = null;
          this.scrollWakeStartY = null;
          this.lens?.classList.add("hidden");
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = 0;
          }
        }
        clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = setTimeout(() => {}, 150);
      }
      bindScroll() {
        if (this.scrollContainer) return;
        this.scrollContainer = this.closest('[id^="Slider-"]') || this.closest(".overflow-x-auto") || this.parentElement;
        this.scrollContainer?.addEventListener("scroll", this.onScroll, {
          passive: true
        });
      }
      unbindScroll() {
        clearTimeout(this.scrollEndTimer);
        this.scrollContainer?.removeEventListener("scroll", this.onScroll);
        this.scrollContainer = null;
        this.scrollSuppressed = false;
        this.scrollWakeStartX = null;
        this.scrollWakeStartY = null;
      }
      hideLens() {
        this.active = false;
        this.scrollSuppressed = false;
        this.scrollWakeStartX = null;
        this.scrollWakeStartY = null;
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = 0;
        }
        this.lens?.classList.add("hidden");
        this.imgRect = null;
        this.unbindScroll();
      }
      addEventListeners() {
        this.addEventListener("mouseenter", this.onMouseEnter);
        this.addEventListener("mousemove", this.onMouseMove, {
          passive: true
        });
        this.addEventListener("mouseleave", this.onMouseLeave);
      }
      removeEventListeners() {
        this.removeEventListener("mouseenter", this.onMouseEnter);
        this.removeEventListener("mousemove", this.onMouseMove);
        this.removeEventListener("mouseleave", this.onMouseLeave);
        this.hideLens();
      }
      connectedCallback() {
        this.style.display = "block";
        this.handleHoverChange = e => e.matches ? this.addEventListeners() : this.removeEventListeners();
        if (this.hoverMQ.matches) this.addEventListeners();
        this.hoverMQ.addEventListener("change", this.handleHoverChange);
      }
      disconnectedCallback() {
        this.removeEventListeners();
        this.hoverMQ.removeEventListener("change", this.handleHoverChange);
        this.unbindScroll();
        this.lens?.remove();
        this.lens = null;
        this.fullResSrc = null;
      }
    });
  })();
})();